import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss']
})
export class ImagePreviewComponent implements OnInit {
  imageSrc;
  constructor(
    public activeModal: NgbActiveModal,
    public domSanitizer: DomSanitizer
  ) { }

  close() {
    this.activeModal.dismiss();
  }
  ngOnInit() {
  }

}
 


// WEBPACK FOOTER //
// ./src/app/image-preview/image-preview.component.ts